import ajax from "@/lib/ajax"
;

// 新增或更新异常提醒设置项
export async function InsertExceptionSetting(payload: any){
	let res = await ajax.post('/api/services/app/SystemBasic/InsertExceptionSetting', payload)
	return res.data.result
}
// 获取异常的信息列表
export async function GetExInfo(payload: any){
	let res = await ajax.get('/api/services/app/SystemBasic/GetExInfo', {params:payload})
	return res.data.result
}
// 获取血压异常患者列表
export async function GetXueYaExList(payload: any){
	let res = await ajax.get('/api/services/app/SystemBasic/GetXueYaExList', {params:payload})
	return res.data.result
}
// 获取血压异常患者列表
export async function GetDlyCompsList(payload: any){
	let res = await ajax.get('/api/services/app/SystemBasic/GetDlyCompsList', {params:payload})
	return res.data.result
}

export async function GetExceptionSetting(payload: any){
	let res = await ajax.get('/api/services/app/SystemBasic/GetExceptionSetting', {params:payload})
	return res.data.result
}



// WEBPACK FOOTER //
// ./src/api/abnormal/index.ts